<template>
    <div>

        <vue-headful title="Jobsites :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-building"></i> Jobsites</li>

                <template v-if="this.$root.hasPermission('jobsites.manage')">
                    <li class="ml-2">
                        <router-link :to="`/jobsites/create`" class="btn btn-sm btn-white"><i class="fa fa-plus-circle text-success"></i> Create</router-link>
                    </li>
                    <li class="ml-2">
                        <router-link :to="`/jobsites/import`" class="btn btn-sm btn-white"><i class="fa fa-file-excel-o"></i> Import</router-link>
                    </li>
                    <li class="ml-2">
                        <a href="/jobsites/map" class="btn btn-sm btn-white"><i class="fa fa-globe"></i> Map</a>
                    </li>
                </template>
            </ol>
        </h4>

        <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none">
            <template v-for="(tab, key) in settingsTabs">
                <b-nav-item :active="curTab === key" @click="curTab = key">
                    {{ tab }}
                </b-nav-item>
            </template>
        </ul>

        <div class="mb-2 mb-lg-0 d-lg-none d-block">
            <b-dropdown :html="tabButtonTitle" variant="default" class="bg-white">
                <template v-for="(tab, key) in settingsTabs">
                    <b-dropdown-item :active="curTab === key" @click="curTab = key">
                        {{ tab }}
                    </b-dropdown-item>
                </template>
            </b-dropdown>
        </div>

        <div v-show="curTab === 'list'">
            <saved-filter-title :filterKey="'jobsiteFilters'" />

            <div class="card">
                <div class="card-body">
                    <jobsite-list :allowFilterSaving="true" :filterId="(filter_id ? parseInt(filter_id) : null)" />
                </div>
            </div>
        </div>

        <template v-if="$root.hasPermission('clients.view')">
            <div v-show="curTab === 'clients'">
                <div class="card">
                    <div class="card-body">
                        <client-list />
                    </div>
                </div>
            </div>
        </template>

        <template v-if="$root.hasPermission('jobsites.manage')">
            <div v-show="curTab === 'check_in'">
                <div class="card">
                    <div class="card-body">
                        <jobsite-check-ins />
                    </div>
                </div>
            </div>

            <div v-show="curTab === 'history'">
                <div class="card">
                    <div class="card-body">
                        <history-list recordType="Jobsite" historyType="Destroy" @historyCount="(total) => { this.history_count = total; }" />
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filter_id: this.$route.query.filter_id,
                curTab: 'list',
            }
        },

        computed: {
            tabButtonTitle(){
                //Send it
                return '<i class="fa fa-bars"></i> ' + this.settingsTabs[this.curTab];
            },

            settingsTabs(){
                //Check Permission
                var tabs = {list: 'Jobsites'};

                if(this.$root.hasPermission('clients.view'))
                {
                    tabs['clients'] = 'Clients';
                }

                if(this.$root.hasPermission('jobsites.manage'))
                {
                    tabs['check_in'] = `QR Check In/Out`;
                    tabs['history'] = 'Delete History';
                }

                //Send it
                return tabs;
            }
        },

        methods: {

        },

        mounted(){
            //Send it
            if(this.$root.hasPermission('clients.view') || this.$root.hasPermission('jobsites.manage'))
            {
                //Check for a hash
                if(window.location.hash)
                {
                    //Set the current tab
                    this.curTab = window.location.hash.replace('#', '');
                }
            }
        },
    }
</script>
